// src/pages/ClientData/api.js
import axios from 'axios';

export const searchClientsByName = (nome) =>
  axios.get('/api/clients/search', { params: { search: nome } });

export const getClientData = (clientCode) =>
  axios.get(`/api/clients/${clientCode}`);

export const getClientProcesses = (clientCode) =>
  axios.get(`/api/clients/${clientCode}/processes`);

export const getProcessDetail = (processCode) =>
  axios.get(`/api/clients/processes/${encodeURIComponent(processCode)}`);

export const getProcessMovements = (processCode, page = 1) =>
  axios.get(`/api/clients/processes/${encodeURIComponent(processCode)}/movements`, {
    params: { page }
  });

export const getMovementFiles = (processCode, reference) =>
  axios.get(
    `/api/clients/processes/${encodeURIComponent(processCode)}/movements/${encodeURIComponent(reference)}`
  );

export const saveClientDocument = (clientCode, conteudo) =>
  axios.post(`/api/clients/${clientCode}/document`, { conteudo });

export const getOneDriveDownloadUrl = (caminho) =>
  axios.get('/api/onedrive/download-url', { params: { caminho } });

export const transcreverOneDriveFile = (caminho, nome) =>
  axios.post('/api/onedrive/transcrever', { caminho, nome });

export const statusOneDriveTranscricao = (jobId, operationName) =>
  axios.get('/api/onedrive/transcrever/status', { params: { jobId, operationName } });

export const salvarOneDriveFicheiro = (nome, texto, clientCode) =>
  axios.post('/api/onedrive/salvar', { nome, texto, clientCode });
